// AuthContext.js
import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
	return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [showLogin, setShowLogin] = useState(false);

	const login = (user) => {
		setUser(user);
		sessionStorage.setItem('user', user);
	};

	const logout = () => {
		setUser(null);
		sessionStorage.removeItem('user');
	};

	const isAuthenticated = () => {
		//return user !== null;
		return sessionStorage.getItem('user');
	};

	return (
		<AuthContext.Provider
			value={{
				user,
				login,
				logout,
				isAuthenticated,
				showLogin,
				setShowLogin,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};
